export const links = [
	{
		name: "Home",
		path: "/",
	},
	{
		name: "About",
		path: "/about",
	},
	{
		name: "Services",
		path: "/services",
	},
	{
		name: "Shop",
		path: "/shop",
	},
	{
		name: "Reservation",
		path: "/reservation",
	},
	{
		name: "Contact",
		path: "/contact",
	},
];

export const foodCategory = [
	{
		id: 1,
		name: "Breakfast Foods",
		description:
			"Start your day with delicious, nutritious, and energizing breakfast options.",
		price: "$2.99",
		imageUrl: require("./assets/food-category/category_card_1.png"),
	},
	{
		id: 2,
		name: "Lunch Foods",
		description:
			"Delicious midday meals to fuel your afternoon with satisfaction.",
		price: "$3.99",
		imageUrl: require("./assets/food-category/category_card_2.png"),
	},
	{
		id: 3,
		name: "Dinner Foods",
		description:
			"Hearty, flavorful dinners: classic, healthy, and international options for every palate.",
		price: "$4.99",
		imageUrl: require("./assets/food-category/category_card_3.png"),
	},
	{
		id: 4,
		name: "Deserts Foods",
		description:
			"Indulge in sweet, irresistible treats to satisfy every dessert craving.",
		price: "$4.99",
		imageUrl: require("./assets/food-category/category_card_4.png"),
	},
	{
		id: 5,
		name: "Traditional Foods",
		description:
			"Experience authentic flavors passed down through generations with traditional foods.",
		price: "$7.99",
		imageUrl: require("./assets/food-category/category_card_5.png"),
	},
];

export const foodMenu = [
	{
		id: 1,
		name: "Breakfast Platter",
		description:
			"Start your day with a hearty and satisfying Breakfast Platter.",
		price: "$20",
		imageUrl: require("./assets/food-menu/product_1_13-100x100.png"),
	},
	{
		id: 2,
		name: "Bruno Scribble",
		description:
			"Bruno Scribble offers unique, artistic dishes with bold, creative flavors.",
		price: "$50",
		imageUrl: require("./assets/food-menu/menu_card_7-100x100.jpg"),
	},
	{
		id: 3,
		name: "Butter Pasta",
		description:
			"Rich, creamy butter pasta with a smooth, savory flavor experience.",
		price: "$28",
		imageUrl: require("./assets/food-menu/product_1_11-100x100.png"),
	},
	{
		id: 4,
		name: "Chicha Morada",
		description:
			"Refreshing Peruvian drink made from purple corn, spices, and fruit.",
		price: "$28",
		imageUrl: require("./assets/food-menu/product_1_9-100x100.png"),
	},
	{
		id: 5,
		name: "Chicken Fried Rice",
		description:
			"Flavorful Chicken Fried Rice: Savory, tender chicken with aromatic rice.",
		price: "$15",
		imageUrl: require("./assets/food-menu/menu_card_1-100x100.jpg"),
	},
];

export const testimonials = [
	{
		id: 1,
		name: "John Doe",
		title: "Food Blogger",
		testimonial:
			"Absolutely loved the dining experience! The food was fresh, flavorful, and beautifully presented. The service was impeccable, and the ambiance made it even better. Can't wait to come back!",
		rating: 5, // Rating out of 5
		imageUrl: require("./assets/testimonial/testi_1_1.jpg"),
	},
	{
		id: 2,
		name: "Sarah Lee",
		title: "Local Guide",
		testimonial:
			"The best restaurant in town by far! Every dish we tried was bursting with flavor, and the staff was incredibly attentive. The cozy atmosphere made it a perfect night out with friends.",
		rating: 4, // Rating out of 5
		imageUrl: require("./assets/testimonial/testi_1_2.jpg"),
	},
	{
		id: 3,
		name: "Michael Jordan",
		title: "Frequent Customer",
		testimonial:
			"I've been here multiple times, and it's always amazing. The chefs really know how to bring out the best in every ingredient. If you want a great meal and fantastic service, this is the place!",
		rating: 5, // Rating out of 5
		imageUrl: require("./assets/testimonial/testi_1_3.jpg"),
	},
	{
		id: 4,
		name: "Emma Watson",
		title: "Health Enthusiast",
		testimonial:
			"A true gem! The healthy, organic options here are fantastic, and I appreciate the focus on local ingredients. Delicious food that makes you feel good afterward—highly recommend!",
		rating: 4, // Rating out of 5
		imageUrl: require("./assets/testimonial/testi_1_4.jpg"),
	},
	{
		id: 5,
		name: "David Kim",
		title: "Business Executive",
		testimonial:
			"The perfect spot for a business lunch or a casual dinner. The menu is diverse, and every dish feels like it’s made with care. Definitely a top pick for anyone looking for great food and service.",
		rating: 5, // Rating out of 5
		imageUrl: require("./assets/testimonial/testi_1_5.jpg"),
	},
	{
		id: 6,
		name: "Isabella Martinez",
		title: "Food Critic",
		testimonial:
			"This restaurant exceeded all my expectations. From the appetizers to dessert, everything was flawless. The attention to detail in both the food and service is truly remarkable.",
		rating: 5, // Rating out of 5
		imageUrl: require("./assets/testimonial/testi_1_6.jpg"),
	},
];

export const ChefData = [
	{
		id: 1,
		name: "John Doe",
		role: "Senior Chef",
		experience: "10 years",
		description:
			"John is the lead farmer with a decade of experience in sustainable farming practices. He specializes in organic crop production and livestock management.",
		image: require("./Components/Chef/team_1_7.jpg"),
	},
	{
		id: 2,
		name: "Jane Smith",
		role: "Master Chef",
		experience: "7 years",
		description:
			"Jane has extensive knowledge in crop rotation, soil management, and pest control. She ensures that our farm produces the best quality crops.",
		image: require("./Components/Chef/team_1_8.jpg"),
	},
	{
		id: 3,
		name: "Tom Brown",
		role: "Sous Chef",
		experience: "8 years",
		description:
			"Tom oversees the care and management of our livestock. His expertise in animal husbandry ensures the health and well-being of all farm animals.",
		image: require("./Components/Chef/team_1_2.jpg"),
	},
	{
		id: 4,
		name: "Emily Davis",
		role: "Pastry Chef",
		experience: "5 years",
		description:
			"Emily is responsible for the irrigation systems on the farm. Her work ensures that our crops receive the right amount of water at the right time.",
		image: require("./Components/Chef/team_1_3.jpg"),
	},
	{
		id: 5,
		name: "Sapphire Davis",
		role: "Sommelier",
		experience: "5 years",
		description:
			"Emily is responsible for the irrigation systems on the farm. Her work ensures that our crops receive the right amount of water at the right time.",
		image: require("./Components/Chef/team_1_4.jpg"),
	},
	{
		id: 6,
		name: "Sapphire Davis",
		role: "Restuarant Manager",
		experience: "5 years",
		description:
			"Emily is responsible for the irrigation systems on the farm. Her work ensures that our crops receive the right amount of water at the right time.",
		image: require("./Components/Chef/team_1_5.jpg"),
	},
	{
		id: 6,
		name: "Johnpeter Maxxwell",
		role: "Executive Director",
		experience: "5 years",
		description:
			"Emily is responsible for the irrigation systems on the farm. Her work ensures that our crops receive the right amount of water at the right time.",
		image: require("./Components/Chef/team_1_6.jpg"),
	},
];

// Shop images

export const shopImages = [
	{
		id: 1,
		name: "Breakfast Platter",
		price: "$29",
		imageUrl: require("./assets/shop-images/product_1_1-312x312.png"),
		ratings: 5,
	},
	{
		id: 2,
		name: "Bruno Scribble",
		price: "$20",
		imageUrl: require("./assets/shop-images/product_1_2.png"),
		ratings: 5,
	},
	{
		id: 3,
		name: "Butter Pasta",
		price: "$20",
		imageUrl: require("./assets/shop-images/product_1_3-312x312.png"),
		ratings: 5,
	},
	{
		id: 4,
		name: "Chicha Morada",
		price: "$25",
		imageUrl: require("./assets/shop-images/product_1_4-312x312.png"),
		ratings: 5,
	},
	{
		id: 5,
		name: "Chicken Fried Rice",
		price: "$35",
		imageUrl: require("./assets/shop-images/product_1_5-312x312.png"),
		ratings: 5,
	},
	{
		id: 6,
		name: "Chicken Leg Piece",
		price: "$35",
		imageUrl: require("./assets/shop-images/product_1_6-312x312.png"),
		ratings: 5,
	},
	{
		id: 7,
		name: "Chicken Leg Piece",
		price: "$35",
		imageUrl: require("./assets/shop-images/product_1_7-312x312.png"),
		ratings: 5,
	},
	{
		id: 8,
		name: "Chicken Leg Piece",
		price: "$35",
		imageUrl: require("./assets/shop-images/product_1_8.png"),
		ratings: 5,
	},
	{
		id: 9,
		name: "Chicken Leg Piece",
		price: "$35",
		imageUrl: require("./assets/shop-images/product_1_9.png"),
		ratings: 5,
	},
	{
		id: 10,
		name: "Chicken Leg Piece",
		price: "$35",
		imageUrl: require("./assets/shop-images/product_1_12.png"),
		ratings: 5,
	},
];

export const shopImagesCarousel = [
	{
		id: 1,
		name: "Breakfast Platter",
		price: "$20",
		slashedPrice: "$29",
		imageUrl: require("./assets/shop-images/product_1_10.png"),
		ratings: 5,
	},
	{
		id: 2,
		name: "Breakfast Platter",
		price: "$15",
		slashedPrice: "$20",
		imageUrl: require("./assets/shop-images/product_1_11.png"),
		ratings: 5,
	},
	{
		id: 3,
		name: "Breakfast Platter",
		price: "$25",
		slashedPrice: "$30",
		imageUrl: require("./assets/shop-images/product_1_12.png"),
		ratings: 5,
	},
	{
		id: 4,
		name: "Breakfast Platter",
		price: "$30",
		slashedPrice: "$35",
		imageUrl: require("./assets/shop-images/product_1_13.png"),
		ratings: 5,
	},
	{
		id: 5,
		name: "Breakfast Platter",
		price: "$55",
		slashedPrice: "$70",
		imageUrl: require("./assets/shop-images/product_1_14.png"),
		ratings: 5,
	},
	{
		id: 6,
		name: "Breakfast Platter",
		price: "$38",
		slashedPrice: "$40",
		imageUrl: require("./assets/shop-images/product_1_1-312x312.png"),
		ratings: 5,
	},
	{
		id: 7,
		name: "Breakfast Platter",
		price: "$20",
		slashedPrice: "$30",
		imageUrl: require("./assets/shop-images/product_1_2.png"),
		ratings: 5,
	},
	{
		id: 8,
		name: "Breakfast Platter",
		price: "$45",
		slashedPrice: "$50",
		imageUrl: require("./assets/shop-images/product_1_3-312x312.png"),
		ratings: 5,
	},
	{
		id: 9,
		name: "Breakfast Platter",
		price: "$55",
		slashedPrice: "$60",
		imageUrl: require("./assets/shop-images/product_1_4-312x312.png"),
		ratings: 5,
	},
	{
		id: 10,
		name: "Breakfast Platter",
		price: "$75",
		slashedPrice: "$80",
		imageUrl: require("./assets/shop-images/product_1_5-312x312.png"),
		ratings: 5,
	},
];

export const moreShopImages = [
	{
		id: 1,
		name: "Breakfast Platter",
		price: "$29",
		imageUrl: require("./assets/shop-images/product_1_1-312x312.png"),
		ratings: 5,
	},
	{
		id: 2,
		name: "Bruno Scribble",
		price: "$20",
		imageUrl: require("./assets/shop-images/product_1_2.png"),
		ratings: 5,
	},
	{
		id: 3,
		name: "Butter Pasta",
		price: "$20",
		imageUrl: require("./assets/shop-images/product_1_3-312x312.png"),
		ratings: 5,
	},
	{
		id: 4,
		name: "Chicha Morada",
		price: "$25",
		imageUrl: require("./assets/shop-images/product_1_4-312x312.png"),
		ratings: 5,
	},
	{
		id: 5,
		name: "Chicken Fried Rice",
		price: "$35",
		imageUrl: require("./assets/shop-images/product_1_5-312x312.png"),
		ratings: 5,
	},
];
